import { render, staticRenderFns } from "./ListWineries.vue?vue&type=template&id=438b5d2d&"
import script from "./ListWineries.vue?vue&type=script&lang=js&"
export * from "./ListWineries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports